module.exports = __webpack_public_path__ + "img/home-logo.1d7bf54e.png";